import { Component, OnInit, Input, Output, ViewChild, EventEmitter, ViewEncapsulation } from '@angular/core';
import { LatitudeUIHistogramComponent } from './histogram/histogram.component';
import { LatitudeUIDateRangeComponent } from './daterange/daterange.component';

@Component({
  selector: 'latitude-ui-timeslider',
  templateUrl: './timeslider.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./timeslider.component.scss']
})
export class LatitudeUITimesliderComponent implements OnInit {

  @Output() onDateChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() startDate: any;
  @Output() endDate: any;
  @Output() data = [];

  @Input() dates: any;
  @Input() wrapperElement;
  @Input() valuesFormatter: any = false;
  @Input() tooltipValueUnits = '';
  @Input() tooltipDecimals = 2;
  @Input() tooltipCompactNumber = false;
  @Input() brushFill: String;

  @ViewChild('clearHistogram') clearHistogram;
  @ViewChild('histogramFiltered') histogramFiltered;
  @ViewChild('totalDaysWrapper') totalDaysWrapper;
  @ViewChild('noDataMsg') noDataMsg;
  @ViewChild('histogramLabel') histogramLabel;

  @ViewChild(LatitudeUIHistogramComponent)
    protected histogramComponent: LatitudeUIHistogramComponent;

  @ViewChild(LatitudeUIDateRangeComponent)
    protected daterangeComponent: LatitudeUIDateRangeComponent;

  private minDateLimit;
  private maxDateLimit;

  showHistogram = true;

  constructor() { }

  ngOnInit() {
    if (this.dates) {
      this.startDate = this.dates.start;
      this.endDate = this.dates.end;
      this.minDateLimit = this.dates.start.clone();
      this.maxDateLimit = this.dates.end.clone();
    }
  }

  updateData(data) {
    this.histogramComponent.refresh(data);
  }

  loadingAnimation() {
    this.histogramComponent.loadingAnimation();
  }

  dateChange($event) {
    if (!$event.start.isValid() || !$event.end.isValid()) {
      return;
    }
    if ($event.from === 'daterange') {
      this.histogramComponent.updateDates($event);
    } else if ($event.from === 'histogram') {
      this.daterangeComponent.updateDates($event);
    }
    if ($event.start.format() !== this.minDateLimit.format() || $event.end.format() !== this.maxDateLimit.format()) {
      this.clearHistogram.nativeElement.classList.remove('hide');
      this.histogramFiltered.nativeElement.classList.remove('hide');
    } else {
      this.clearHistogram.nativeElement.classList.add('hide');
      this.histogramFiltered.nativeElement.classList.add('hide');
      this.daterangeComponent.resetHours();
    }
    this.onDateChange.emit({start: $event.start, end: $event.end, step: $event.step ? $event.step : null});
  }

  updateDates(dates) {
    this.minDateLimit = dates.start;
    this.maxDateLimit = dates.end;

    this.daterangeComponent.updateDates(dates);
    this.histogramComponent.updateDates(dates, true);
    const step = this.histogramComponent.getStep(dates.start, dates.end);
    this.onDateChange.emit({start: dates.start, end: dates.end, step: step ? step : null});
  }

  getStep() {
    return this.histogramComponent.getStep(this.minDateLimit, this.maxDateLimit);
  }

  resetHistogram($event) {
    this.histogramComponent.clearHistogram();
  }

  noData($event) {
    if ($event) {
      // @TODO: translate
      this.noDataMsg.nativeElement.innerHTML = 'No data found';
    } else {
      this.noDataMsg.nativeElement.innerHTML = '';
    }
  }

  totalDays($event) {
    // @TODO: translate
    this.totalDaysWrapper.nativeElement.innerHTML = $event + ' days';
  }

  toggleHistogram() {
    this.showHistogram = !this.showHistogram;
  }

  refreshOnlyData(data) {
    this.histogramComponent.refreshOnlyData(data);
  }

}



// WEBPACK FOOTER //
// ./src/latitude-ui/timeslider/timeslider.component.ts